<template>
  <div class="school-name-container">
    <h1 :class="['school-name', { 'small-name': isLongName }]">
      {{ name }}
    </h1>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useSchoolStore } from "@/Store/schoolStore";

const schoolStore = useSchoolStore();
schoolStore.fetchSchoolDetails();
const name = computed(() => schoolStore.details.name || '');
const isLongName = computed(() => name.value.length > 20);
</script>


<style>
.school-name-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 10px;
}
.school-name {
  /* font-size: 1.5rem;
  font-weight: bold;
   color: #424242;
  text-align: center; */
  font-weight: 700;
  color: #424242;
  display: block;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: block;
}

.small-name {
  font-size: 1.3rem; /* smaller font for long names */
}
</style>